var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKmh = function SvgKmh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    d: "M9.143 3.905V2h5.714v1.905zm.953 11.19L9.048 13a.82.82 0 0 0-.357-.393 1 1 0 0 0-.5-.13H3.477Q3.834 9.26 6.262 7.06 8.692 4.858 12 4.857q1.477 0 2.834.476a9.3 9.3 0 0 1 2.547 1.381l1.334-1.333 1.333 1.333-1.333 1.334q.761 1 1.214 2.107t.595 2.321h-4.119L14.762 9.19q-.261-.547-.857-.547-.595 0-.857.547zM12 22q-3.31 0-5.738-2.202t-2.785-5.417h4.119l1.642 3.286q.262.547.858.547.594 0 .857-.547l2.952-5.905 1.048 2.095q.12.262.357.394.238.13.5.13h4.714q-.356 3.214-2.786 5.416Q15.31 22 12 22"
  })));
};
export default SvgKmh;